module.exports = ".red {\n    color:red;\n    font-weight: 500;\n}\n.termsit ul{\n    margin-left: 20px;\n}"